<ng-container>
  <div class="row">
    <div class="col-12">
      <cap-breadcrumb></cap-breadcrumb>
    </div>
  </div>
  @if (grundstueckEntry) {
    <div class="row d-lg-none d-xl-none d-md-none">
      <div class="col-md-0 col-lg-3 col-xl-2">
        <div style="margin-bottom: 20px">
          <cap-grundstueck-menu [fixMenu]="false" [grundstueckEntry]="grundstueckEntry"></cap-grundstueck-menu>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-9 col-lg-9 col-xl-10">
        <div>
          <cap-grundstueck-kopf [grundstueckEntry]="grundstueckEntry"></cap-grundstueck-kopf>
          <router-outlet></router-outlet>
        </div>
      </div>
      <div class="col-md-3 col-lg-3 col-xl-2 d-none d-lg-block d-xl-block d-md-block">
        <cap-grundstueck-menu [fixMenu]="true" [grundstueckEntry]="grundstueckEntry"></cap-grundstueck-menu>
      </div>
    </div>
  } @else {
    <cap-spinner-small></cap-spinner-small>
  }
</ng-container>
